import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/redux.store'
import { mapAllBoardStickersToBoardStickerRows } from '../../lib/taskTrackerBoardStickerRows.utils'
import type { BoardStickerRow } from '../domain.types'
import type { TaskTrackerState } from '../index'
import {
  createEmptyBoardKanbanBoardState,
} from './boardKanban.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardReloadToken = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return 0
  return state.taskTracker.boardKanban.reloadTokens[boardId] ?? 0
}

export const selectTaskTrackerBoardKanban = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return createEmptyBoardKanbanBoardState()
  return (
    state.taskTracker.boardKanban.byBoardId[boardId] ??
    createEmptyBoardKanbanBoardState()
  )
}

export const selectTaskTrackerBoardColumns = (
  state: AppState,
  boardId: number | null,
) => selectTaskTrackerBoardKanban(state, boardId).columns

const EMPTY_BOARD_KANBAN_STICKER_ROWS: BoardStickerRow[] = []

export const selectTaskTrackerBoardKanbanStickerRows = (
  state: AppState,
  boardId: number | null,
): BoardStickerRow[] => {
  if (boardId == null) return EMPTY_BOARD_KANBAN_STICKER_ROWS

  const stickers = selectTaskTrackerBoardKanban(state, boardId).stickers
  if (stickers.length === 0) return EMPTY_BOARD_KANBAN_STICKER_ROWS

  return mapAllBoardStickersToBoardStickerRows(stickers)
}

export const makeSelectTaskTrackerBoardKanbanStickerRows = (
  boardId: number | null,
) =>
  createSelector(
    [(state: AppState) => selectTaskTrackerBoardKanbanStickerRows(state, boardId)],
    (rows) => rows,
  )
